import { FormControl, FormLabel, Switch, VStack } from "@chakra-ui/react";
import { useDispatch, useSelect } from "@wordpress/data";
import React from "react";
import { BLOCKS } from "../../../base/constants/blocks";
import { withChakraUIProvider } from "../../hoc";
import { preferencesStore } from "../../store/preferences-store";
import { ScrollArea } from "../scroll-area/ScrollArea";

export const InsertersSidebar = () => {
	const inserters = useSelect(
		(select) => select(preferencesStore).getInserters() as string[],
		[]
	);
	const { updateInserters } = useDispatch("magazine-blocks/preferences");
	return (
		<ScrollArea h={"full"}>
			<VStack gap="12px" h="calc(100% - 35px)" w="auto" p="20px">
				{Object.entries(BLOCKS).map(
					([id, { label, icon: Icon, blockName }]) => {
						return (
							<FormControl
								key={id}
								display="flex"
								justifyContent="space-between"
								alignItems="center"
							>
								<FormLabel
									display="flex"
									alignItems="center"
									gap="2"
								>
									<Icon w="8" h="8" fill="primary.500" />
									{label}
								</FormLabel>
								<Switch
									onChange={(e) => {
										if (e.target.checked) {
											updateInserters([
												...inserters,
												blockName,
											]);
										} else {
											updateInserters(
												inserters.filter(
													(i) => i !== blockName
												)
											);
										}
									}}
									isChecked={inserters.includes(blockName)}
								/>
							</FormControl>
						);
					}
				)}
			</VStack>
		</ScrollArea>
	);
};

export default withChakraUIProvider(InsertersSidebar);
